import { useEffect, useState } from "react";
import { customerFormsApi } from "../../shared/customerFormsApi";
import type { CustomerFormPage, FormOptions } from "../../types/forms";

export function useCustomerForms(query: string) {
  const [page, setPage] = useState<CustomerFormPage | null>(null);
  const [options, setOptions] = useState<FormOptions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [optionsError, setOptionsError] = useState("");
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    customerFormsApi.options().then((result) => {
      if (!active) return;
      if (result.success) {
        setOptions(result.data);
        setOptionsError("");
      } else setOptionsError(result.data.message || "Could not load form options.");
    });
    return () => {
      active = false;
    };
  }, [revision]);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    const timer = setTimeout(() => {
      customerFormsApi.list(new URLSearchParams(query)).then((result) => {
        if (!active) return;
        setLoading(false);
        if (result.success) setPage(result.data);
        else {
          setPage(null);
          setError(result.data.message || "Could not load forms. Check your connection and retry.");
        }
      });
    }, 250);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [query, revision]);
  return {
    page,
    options,
    loading,
    error: error || optionsError,
    refresh: () => setRevision((value) => value + 1),
  };
}
